<div class="dialog-container dialog-container--width">
    <div class="dialog-title-block">
        <h2>Delete User?</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <div class="dialog-content-block p-4">
        <div class="">
            <p class="text-para text-grey-100">You are about to detele “<span class="text-capitalize">{{ dialogData.fullName ? dialogData.fullName : '-' }}</span>” user. Are you sure do you what to delete this user?</p>
        </div>
    </div>
    <div class="dialog-footer">
        <button class="px-4 py-2" type="button" (click)="onClose()">No</button>
        <button class="px-4 py-2" type="submit" (click)="submit()">Yes, Delete</button>
    </div>
</div>

